import React from 'react';
import { Gift, CheckCircle2 } from 'lucide-react';
export function BonusSection() {
  const blueprints = ['Pipeline de Leads con Scoring e IA.', 'Clasificador de Emails Inteligente.', 'Chatbot de WhatsApp con Catálogo.', 'Extracción de Facturas PDF con OCR.'];
  return <section className="py-20 bg-black text-white px-4 border-y-8 border-brand-yellow relative" data-id="element-22">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-yellow text-black font-black text-xl md:text-2xl px-8 py-2 rounded-full shadow-lg uppercase tracking-wider" data-id="element-23">
        Solo por hoy
      </div>

      <div className="max-w-6xl mx-auto mt-8" data-id="element-24">
        <div className="text-center mb-12" data-id="element-25">
          <div className="flex justify-center mb-4" data-id="element-26">
            <Gift className="w-16 h-16 text-brand-yellow animate-bounce" data-id="element-27" />
          </div>
          <h2 className="text-4xl md:text-6xl font-black mb-6 text-transparent bg-clip-text bg-gradient-to-r from-brand-yellow to-orange-500" data-id="element-28">
            BONUS EXCLUSIVO: <br className="hidden md:block" data-id="element-29" />
            La Bóveda de 80 Blueprints (JSON).
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto" data-id="element-30">
            No empieces desde una hoja en blanco. Te entrego mis{' '}
            <span className="text-brand-yellow font-bold" data-id="element-31">
              80 flujos maestros
            </span>{' '}
            listos para importar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-32">
          <div className="order-2 md:order-1" data-id="element-33">
            <a href="#compra" className="block cursor-pointer transform hover:scale-105 transition-transform duration-300 relative group" data-id="element-34">
              <div className="absolute inset-0 bg-brand-yellow rounded-xl blur-xl opacity-20 group-hover:opacity-40 transition-opacity" data-id="element-35"></div>
              <img src="https://cdn.magicpatterns.com/uploads/ubmyg3kA736MVZC5WYYpLU/Flujos_listos_para_proyectos_rapidos.png" alt="80 Blueprints de n8n" className="w-full max-w-md mx-auto rounded-xl shadow-2xl relative z-10 border-2 border-gray-800 aspect-square object-cover" data-id="element-36" />
              <div className="absolute top-4 right-4 bg-brand-red text-white font-bold px-4 py-2 rounded-lg z-20 shadow-lg transform rotate-3" data-id="element-37">
                GRATIS HOY
              </div>
            </a>
          </div>

          <div className="order-1 md:order-2 space-y-8" data-id="element-38">
            <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800" data-id="element-39">
              <h3 className="text-2xl font-bold mb-6 text-white" data-id="element-40">
                Algunos de los flujos incluidos:
              </h3>
              <ul className="space-y-4" data-id="element-41">
                {blueprints.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-42">
                    <CheckCircle2 className="w-6 h-6 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-43" />
                    <span className="text-lg text-gray-300" data-id="element-44">{item}</span>
                  </li>)}
                <li className="flex items-start gap-3 pt-2" data-id="element-45">
                  <span className="text-brand-yellow font-bold text-lg italic" data-id="element-46">
                    + 76 flujos profesionales más...
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-brand-red/10 border-2 border-brand-red p-6 rounded-xl text-center" data-id="element-47">
              <p className="text-lg text-gray-300 mb-2" data-id="element-48">
                Valor real de estos flujos:
              </p>
              <p className="text-3xl font-black text-white line-through decoration-brand-red decoration-4 mb-2" data-id="element-49">
                +$1,500 USD
              </p>
              <p className="text-2xl font-bold text-brand-yellow uppercase" data-id="element-50">
                Para ti, incluidos hoy GRATIS.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}